<template>
  <div class="step-4">
    <div>游戏总人数为：{{ formValue.playersNum || 0 }}</div>
    <div>
      共有{{ formValue.playerList.length || 0 }}位参与者进入，{{
        formValue.playersNum - formValue.playerList.length || 0
      }}位未进入
    </div>

    <div class="step-4-people">
      <Grid :column-num="4" :border="false">
        <template v-for="item in formValue.playerList">
          <GridItem class="step-4-people-item" :key="item.userId">
            <img class="step-4-people-item-avatar" :src="item.avatar" alt="" />
            <div>{{ item.nickName }}</div>
          </GridItem>
        </template>
      </Grid>
    </div>

    <!-- <div class="step-4-select">
      <div>增加</div>
      <NfDropdownMenu width="130px" style="margin: 0 0.1rem" />
      <div>参与者</div>
    </div> -->
  </div>
</template>

<script>
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import { Grid, GridItem } from "vant";
export default {
  components: {
    NfDropdownMenu,
    Grid,
    GridItem,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.step-4 {
  &-people {
    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      &-avatar {
        width: 1rem;
        height: 1rem;
        border-radius: 0.1rem;
        margin-bottom: 0.01rem;
      }
    }
  }
  &-select {
    display: flex;
    width: 100%;
    align-items: center;
  }
}
</style>
